import React from 'react';
import styles from './index.css';
class Nav extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isClickMore: false,
        };
        this.loadMore = () => {
            const { isClickMore } = this.state;
            this.setState({
                isClickMore: !isClickMore,
            });
        };
    }
    /**
     * 渲染网页布局
     */
    render() {
        const { content, moreNum, showNum } = this.props;
        const { isClickMore } = this.state;
        const navItem = content.slice(0, isClickMore ? moreNum : showNum).map((item, index) => (React.createElement("li", { className: styles.item, key: index },
            React.createElement("a", { href: item.url, className: styles.link },
                item.title,
                item.redHot && React.createElement("span", { className: styles.redHot })))));
        return (React.createElement("nav", { className: styles.nav },
            React.createElement("ul", { className: styles.navbox },
                navItem,
                React.createElement("li", { onClick: this.loadMore, className: isClickMore ? `${styles.more} ${styles.turn} ` : styles.more }))));
    }
}
Nav.defaultProps = {
    showNum: 13,
    moreNum: 34,
};
export default Nav;
